<script lang='ts'>
  import * as _ from 'lodash';
  import Modal from '@shared/svelte/Components/Modal.svelte'
  import ProductChooser from '@shared/svelte/ProductChooser/ProductChooser.svelte';
  import type { ProductChooserOptionsType } from '@shared/types/Filters'

  export let callbacks: any;
  export let page: any;
  export let closeAddProduct: any;
  export let closeAddProductAndSave: any;
  export let showAddProductsModal : boolean;
  export let selectMultipleChoices : object = {};
  export let initialFilterStateParams : object = {};

  let productChooserOptions:ProductChooserOptionsType= {selectMultiple: true, maxRequired: false, minRequired: false};
</script>

<Modal show={showAddProductsModal} closeOnBackgroundClick={false} fizzModal={true}>
  <ProductChooser onSelectProduct={closeAddProductAndSave}
    bind:externalLoading={page.loadingProducts} {initialFilterStateParams}
    productLines={page.searchResults} {selectMultipleChoices}
    pullFilters={callbacks.pullAvailableFilters}
    pullProductLines={callbacks.pullProductLines} {productChooserOptions}
    onCloseProductChooser={closeAddProduct}></ProductChooser>
</Modal>